export const ANONYMOUS_USER_KEY = "anonymous-user";
export const DISABLE_FEATURE_FLAG_PROVIDER_COOKIE_KEY = "DISABLE_FEATURE_FLAGS_PROVIDER";
export const FEATURE_FLAGS_COOKIE_KEY = "flags-4e34bc42-a83c-45ff-a260-0bb034412e99";
